<template>
  <transition :name="'imbee-' + callToAction.animation">
    <div
      class="bubble-call-to-action"
      v-show="!opened && show"
      :style="{
        bottom: callToAction.verticalPadding,
        [alignment]: callToAction.horizontalPadding,
        alignItems: alignment == 'left' ? 'flex-start' : 'flex-end',
      }"
    >
      <div class="call-to-action-close">
        <div
          class="close-cta"
          @click.prevent="closeCTA"
          id="close-cta"
          style="background: rgba(0, 0, 0, 0.4)"
        >
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
              fill="#ffffff"
            />
          </svg>
        </div>
      </div>
      <div
        @click.prevent="open"
        class="call-to-action-content-wrapper"
        v-bind:style="{
          backgroundColor: callToAction.backgroundColor,
          color: callToAction.fontColor,
          fontSize: callToAction.fontSize,
          fontFamily: callToAction.fontFamily,
          fontWeight: callToAction.fontWeight,
        }"
      >
        {{ callToAction.text }}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "CallToAction",
  props: {
    opened: { type: Boolean, default: false },
    show: { type: Boolean, default: false },
    alignment: { type: String, default: "right" },
    callToAction: { type: Object, default: {} },
  },
  methods: {
    closeCTA() {
      this.callToAction.showCta = false;
    },
    open() {
      this.$emit("open");
    },
  },
  updated() {
    if (this.opened) {
      this.callToAction.showCta = false;
    }
  },
};
</script>

<style scoped>
.bubble-call-to-action {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 240px;
  display: -webkit-box; 
  display: -moz-box; 
  display: -ms-flexbox; 
  display: -webkit-flex; 
  display: flex; 
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: inherit;
  -ms-flex-align: inherit;
  padding: 20px;
  position: absolute;
  align-items: flex-end;
}

.bubble-call-to-action:hover .call-to-action-close {
  opacity: 1;
}

.call-to-action-close {
  opacity: 0;
  margin-bottom: 8px;
}

.close-cta {
  width: 20px;
  height: 20px;
  padding: 2px;
  display: -webkit-box; 
  display: -moz-box; 
  display: -ms-flexbox; 
  display: -webkit-flex; 
  display: flex; 
  border-radius: 100%;
  -webkit-backface-visibility: hidden;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  cursor: pointer;
  float: right;
}

.call-to-action-content-wrapper {
  word-wrap: break-word;
  font-size: 16px;
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  -webkit-transition: opacity 0.3s, -webkit-box-shadow 0.3s;
  transition: opacity 0.3s, -webkit-box-shadow 0.3s;
  transition: box-shadow 0.3s, opacity 0.3s;
  transition: box-shadow 0.3s, opacity 0.3s, -webkit-box-shadow 0.3s;
  cursor: pointer;
  padding: 15px 20px;
  max-width: 100%;
  line-height: 22px;
  text-align: left;
  z-index: 999;
}

.call-to-action-content-wrapper:hover {
  -webkit-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}

.close-cta svg {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// CallToAction.vue?3cde2cea